import {useContext} from "react";
import {AuthContext} from "../providers/AuthProviders";

const Export = () => useContext(AuthContext);

export default Export;